import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import HttpBackend from "i18next-http-backend";
import LanguageDetector from "i18next-browser-languagedetector";
import { DEFAULT_LANG, SUPPORTED_LANGS } from "./routesLocalized";


i18n
    .use(HttpBackend)
    .use(LanguageDetector)
    .use(initReactI18next)
    .init({
        fallbackLng: DEFAULT_LANG,
        debug: false,
        nonExplicitSupportedLngs: true,
        load: "languageOnly",
        supportedLngs: SUPPORTED_LANGS,
        interpolation: {
            escapeValue: false,
        },
        // Default namespace
        ns: ['default'],
        defaultNS: "main",
        fallbackNS: "main",
        backend: {
            loadPath: "/locales/{{lng}}/{{ns}}.json",
        },
        /* backend: {
             loadPath: (lngs, namespaces) => {
                 return `/locales/${lngs[0]}/${namespaces[0]}.json`;
             },
         },*/

        react: {
            useSuspense: true,
            //transKeepBasicHtmlNodesFor: ["b"],
            transKeepBasicHtmlNodesFor: [],
            transSupportBasicHtmlNodes: false,
        },
        detection: {
            order: ["querystring", "localStorage", "cookie", "navigator"],
            caches: ["localStorage"],

            lookupQuerystring: "lng",
            convertDetectedLanguage: (lng) => lng.split("-")[0],
        },
    });

export default i18n;